import initialState from './initialState'
import { AnyAction } from 'redux'
import { DebinActionTypes, DebinState } from './types'

export default function debinReducer(
  state = initialState,
  action: AnyAction
): DebinState {
  switch (action.type) {
    case DebinActionTypes.GET_RECURRENCES_PENDING:
      return {
        ...state,
        isLoading: true
      }
    case DebinActionTypes.GET_RECURRENCES_FULFILLED:
      return {
        ...state,
        isLoading: initialState.isLoading,
        recurrences: action.payload
      }
    case DebinActionTypes.GET_RECURRENCES_REJECTED:
      return {
        ...state,
        isError: true,
        isLoading: initialState.isLoading,
        recurrences: initialState.recurrences
      }
    case DebinActionTypes.CONFIRM_RECURRENCE_PENDING:
      return {
        ...state,
        isLoading: true
      }
    case DebinActionTypes.CONFIRM_RECURRENCE_FULFILLED:
      return {
        ...state,
        isLoading: initialState.isLoading
      }
    case DebinActionTypes.CONFIRM_RECURRENCE_REJECTED:
      return {
        ...state,
        isError: true,
        isLoading: initialState.isLoading
      }
    case DebinActionTypes.CANCEL_RECURRENCE_PENDING:
      return {
        ...state,
        isLoading: true
      }
    case DebinActionTypes.CANCEL_RECURRENCE_FULFILLED:
      return {
        ...state,
        isLoading: initialState.isLoading
      }
    case DebinActionTypes.CANCEL_RECURRENCE_REJECTED:
      return {
        ...state,
        isError: true,
        isLoading: initialState.isLoading
      }
    case DebinActionTypes.GET_DEBIN_MOVEMENTS_PENDING:
      return {
        ...state,
        isDebinMovementsLoading: true
      }
    case DebinActionTypes.GET_DEBIN_MOVEMENTS_FULFILLED:
      return {
        ...state,
        isDebinMovementsLoading: initialState.isLoading,
        debinMovements: action.payload
      }
    case DebinActionTypes.GET_DEBIN_MOVEMENTS_REJECTED:
      return {
        ...state,
        isError: true,
        isDebinMovementsLoading: initialState.isLoading
      }
    default:
      return state
  }
}
